var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"star-rating",class:{
    'controlled': _vm.controlled
  }},[_c('div',{staticClass:"star-rating-container"},_vm._l((_vm.reversedLevels),function(item){return _c('span',{key:item,staticClass:"rate",class:{
        checked: item === Math.ceil(_vm.rate),
        'star-half': _vm.isStarHalf(_vm.rate, item)
      },style:({
        '--size': _vm.size
      }),on:{"click":function($event){return _vm.handleClick(item)}}},[(_vm.isStarHalf(_vm.rate, item))?_c('aha-svg',{attrs:{"name":"star-half","width":_vm.size,"height":_vm.size,"viewBox":"0 0 20 20","maintainColor":true}}):_c('aha-svg',{attrs:{"name":"star-fill","width":_vm.size,"height":_vm.size,"viewBox":"0 0 20 20"}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }